export const ACCESS_LEVELS = {
  TEACHER: 30,
  PROFESSOR_SCHOOL_GLOBAL: 30,
  SECRETARY: 80,
  ADMIN: 100,
  FINANCIAL_ADMIN: 120,
} as const;
